var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _g2, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g3, _path28;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPollyShock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 174,
    viewBox: "0 0 175 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.0012 174C135.05 174 174.001 135.049 174.001 87.0002C174.001 38.9513 135.05 0 87.0012 0C38.9523 0 0.000976562 38.9513 0.000976562 87.0002C0.000976562 135.049 38.9523 174 87.0012 174Z",
    fill: "#FAAB35"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_816_29110",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 175,
    height: 175
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0012 174C135.05 174 174.001 135.049 174.001 87.0002C174.001 38.9513 135.05 0 87.0012 0C38.9523 0 0.000976562 38.9513 0.000976562 87.0002C0.000976562 135.049 38.9523 174 87.0012 174Z",
    fill: "#FAAB35"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_816_29110)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_816_29110",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 108,
    width: 49,
    height: 52
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.836 142.954C109.911 142.148 108.703 141.645 108.703 141.645C101.053 137.595 102.403 118.696 102.403 118.696C102.403 118.696 94.2692 112.497 87.7248 108.894V108.582C87.6311 108.632 87.5374 108.687 87.4438 108.738C87.3493 108.687 87.2565 108.632 87.162 108.582V108.894C80.6175 112.497 72.484 118.696 72.484 118.696C72.484 118.696 73.8342 137.596 66.184 141.645C66.184 141.645 64.9767 142.149 63.0503 142.954C67.5302 152.825 76.7567 159.616 87.4438 159.616C98.1308 159.616 107.357 152.825 111.836 142.954Z",
    fill: "#A06A4B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_816_29110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.836 142.954C109.911 142.148 108.703 141.645 108.703 141.645C101.053 137.595 102.403 118.696 102.403 118.696C102.403 118.696 94.2692 112.497 87.7248 108.894V108.582C87.6311 108.632 87.5374 108.687 87.4438 108.738C87.3493 108.687 87.2565 108.632 87.162 108.582V108.894C80.6175 112.497 72.484 118.696 72.484 118.696C72.484 118.696 73.8342 137.596 66.184 141.645C66.184 141.645 64.9767 142.149 63.0503 142.954C67.5302 152.825 76.7567 159.616 87.4438 159.616C98.1308 159.616 107.357 152.825 111.836 142.954Z",
    fill: "#A06A4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.684 125.767C106.684 125.767 90.6529 145.173 61.797 141.798C52.8578 140.753 68.7716 115.021 68.7716 115.021L102.717 118.621L106.684 125.767Z",
    fill: "#764D34"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.59 145.597H111.302C111.302 152.446 100.647 157.997 87.5044 157.997C74.3607 157.997 63.7054 152.446 63.7054 145.597H57.18C57.18 145.597 33.185 152.078 34.0224 155.158C39.4516 175.137 61.3337 190.08 87.5044 190.08C113.48 190.08 135.23 175.359 140.862 155.604C141.779 152.388 117.59 145.597 117.59 145.597Z",
    fill: "#A2DADD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0176 129.986C72.0176 129.986 57.2856 131.234 57.2856 145.595C57.2856 159.955 73.9369 168.338 87.4084 167.815C91.1636 167.67 89.6325 151.527 89.6325 151.527C89.6325 151.527 69.2276 153.839 72.0176 129.986Z",
    fill: "#26ACAF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.871 129.986C102.871 129.986 117.602 131.234 117.602 145.595C117.602 159.955 100.88 168.338 87.4083 167.815C83.6515 167.67 85.2556 151.527 85.2556 151.527C85.2556 151.527 105.661 153.839 102.871 129.986Z",
    fill: "#26ACAF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M107.112 57.3213C100.626 57.3213 95.368 52.0628 95.368 45.5762C95.368 39.0905 100.626 33.8319 107.112 33.8319C113.599 33.8319 118.857 39.0905 118.857 45.5762C118.857 52.0628 113.599 57.3213 107.112 57.3213Z",
    fill: "#231F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5354 54.3368C79.7106 54.3368 73.3669 47.9932 73.3669 40.1684C73.3669 32.3436 79.7106 26 87.5354 26C95.3601 26 101.704 32.3436 101.704 40.1684C101.704 47.9932 95.3601 54.3368 87.5354 54.3368Z",
    fill: "#231F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M118.692 67.2742C113.195 67.2742 108.739 62.8181 108.739 57.3213C108.739 51.8238 113.195 47.3677 118.692 47.3677C124.188 47.3677 128.644 51.8238 128.644 57.3213C128.644 62.8181 124.188 67.2742 118.692 67.2742Z",
    fill: "#231F20"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M118.857 81.2537C113.36 81.2537 108.905 76.7975 108.905 71.3008C108.905 65.8033 113.36 61.3472 118.857 61.3472C124.354 61.3472 128.809 65.8033 128.809 71.3008C128.809 76.7975 124.354 81.2537 118.857 81.2537Z",
    fill: "#231F20"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M114.415 94.8426C108.918 94.8426 104.462 90.3865 104.462 84.8898C104.462 79.3923 108.918 74.9362 114.415 74.9362C119.912 74.9362 124.368 79.3923 124.368 84.8898C124.368 90.3873 119.912 94.8426 114.415 94.8426Z",
    fill: "#231F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7758 57.3213C74.2623 57.3213 79.5201 52.0628 79.5201 45.5762C79.5201 39.0905 74.2623 33.8319 67.7758 33.8319C61.2893 33.8319 56.0315 39.0905 56.0315 45.5762C56.0315 52.0628 61.2893 57.3213 67.7758 57.3213Z",
    fill: "#231F20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1966 67.2742C61.6933 67.2742 66.1494 62.8181 66.1494 57.3213C66.1494 51.8238 61.6933 47.3677 56.1966 47.3677C50.6999 47.3677 46.2438 51.8238 46.2438 57.3213C46.2438 62.8181 50.6999 67.2742 56.1966 67.2742Z",
    fill: "#231F20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0314 81.2537C61.5281 81.2537 65.9842 76.7975 65.9842 71.3008C65.9842 65.8033 61.5281 61.3472 56.0314 61.3472C50.5347 61.3472 46.0786 65.8033 46.0786 71.3008C46.0778 76.7975 50.5339 81.2537 56.0314 81.2537Z",
    fill: "#231F20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4725 94.8426C65.9692 94.8426 70.4253 90.3865 70.4253 84.8898C70.4253 79.3923 65.9692 74.9362 60.4725 74.9362C54.9758 74.9362 50.5197 79.3923 50.5197 84.8898C50.5197 90.3873 54.9758 94.8426 60.4725 94.8426Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_816_29110",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 47,
    width: 64,
    height: 83
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M116.418 64.5928C111.919 49.0679 95.7181 47.4931 88.9681 47.4931H87.0623H85.1557C78.4057 47.4931 62.2061 49.0679 57.7063 64.5928C53.2248 80.0519 51.7405 129.374 87.0623 129.374C122.39 129.374 120.899 80.0519 116.418 64.5928Z",
    fill: "#A06A4B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_816_29110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.418 64.5928C111.919 49.0679 95.7181 47.4931 88.9681 47.4931H87.0623H85.1557C78.4057 47.4931 62.2061 49.0679 57.7063 64.5928C53.2248 80.0519 51.7405 129.374 87.0623 129.374C122.39 129.374 120.899 80.0519 116.418 64.5928Z",
    fill: "#A06A4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6364 57.4928C96.6364 57.4928 119.028 73.2431 107.653 86.5773C98.7263 97.0421 107.653 97.543 107.653 97.543C107.653 97.543 110.24 116.893 105.965 123.193C123.287 122.281 175.409 62.2997 96.6364 57.4928Z",
    fill: "#764D34"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7384 115.596C76.6886 115.596 83.133 109.1 83.133 101.086C83.133 93.0733 76.6886 86.5773 68.7384 86.5773C60.7882 86.5773 54.3438 93.0733 54.3438 101.086C54.3438 109.1 60.7882 115.596 68.7384 115.596Z",
    fill: "#A06A4B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M105.966 115.596C113.916 115.596 120.361 109.1 120.361 101.086C120.361 93.0733 113.916 86.5773 105.966 86.5773C98.015 86.5773 91.5706 93.0733 91.5706 101.086C91.5706 109.1 98.015 115.596 105.966 115.596Z",
    fill: "#A06A4B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M118.247 94.0553C118.247 94.0553 118.337 56.4212 88.1257 56.4212C57.9125 56.4212 73.0191 52.9931 73.0191 52.9931L87.1661 43.149C87.1661 43.149 132.447 38.6492 118.247 94.0553Z",
    fill: "#F47C24"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1051 94.0553C56.1051 94.0553 56.0146 56.4212 86.2271 56.4212C99.2803 56.4212 101.972 56.8126 101.334 52.9931C100.392 47.3678 87.1867 43.149 87.1867 43.149C87.1867 43.149 41.9057 38.6492 56.1051 94.0553Z",
    fill: "#FAAB35"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7377 101.087C66.9445 101.087 69.5448 98.4867 69.5448 95.2799C69.5448 92.0732 66.9445 89.4729 63.7377 89.4729C60.531 89.4729 57.9307 92.0732 57.9307 95.2799C57.9307 98.4867 60.5302 101.087 63.7377 101.087Z",
    fill: "#AF8065"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M111.15 101.087C114.357 101.087 116.957 98.4867 116.957 95.2799C116.957 92.0732 114.357 89.4729 111.15 89.4729C107.943 89.4729 105.344 92.0732 105.344 95.2799C105.344 98.4867 107.943 101.087 111.15 101.087Z",
    fill: "#AF8065"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5353 86.5773C88.5353 86.5773 92.7128 96.9858 92.5008 98.4431C91.0388 101.087 88.5353 101.087 88.5353 101.087C88.5353 101.087 89.8473 98.4962 89.6886 96.5301C89.5703 95.0784 88.5353 86.5773 88.5353 86.5773Z",
    fill: "#764D34"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9068 71.5779C81.667 69.7229 79.9144 68.5584 77.965 68.5584C74.9106 68.5584 72.327 71.4016 71.4681 75.3164C73.1477 72.6573 76.0751 70.8913 79.4136 70.8913C80.6494 70.8913 81.8258 71.1389 82.9068 71.5779Z",
    fill: "#231F20"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M91.981 71.5779C93.2208 69.7229 94.9734 68.5584 96.9228 68.5584C99.9772 68.5584 102.562 71.4016 103.42 75.3164C101.741 72.6573 98.8128 70.8913 95.4742 70.8913C94.2384 70.8913 93.062 71.1389 91.981 71.5779Z",
    fill: "#231F20"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1321 90.5969C76.3235 90.5969 77.2887 88.7974 77.2887 86.5773C77.2887 84.3572 76.3235 82.557 75.1321 82.557C73.9407 82.557 72.9755 84.3572 72.9755 86.5773C72.9755 88.7974 73.9407 90.5969 75.1321 90.5969Z",
    fill: "#231F20"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5715 90.5969C100.763 90.5969 101.728 88.7974 101.728 86.5773C101.728 84.3572 100.763 82.557 99.5715 82.557C98.3801 82.557 97.4149 84.3572 97.4149 86.5773C97.4149 88.7974 98.3801 90.5969 99.5715 90.5969Z",
    fill: "#231F20"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2113 111.823C99.2113 108.605 93.9424 104.942 87.4432 104.942C80.944 104.942 75.6759 108.605 75.6759 111.823V112.465C75.6759 112.465 75.6759 115.596 79.0287 115.596H96.1205C96.1205 115.596 99.2113 115.596 99.2113 112.554V111.823Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_816_29110",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 75,
    y: 104,
    width: 25,
    height: 12
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2113 111.823C99.2113 108.605 93.9424 104.942 87.4432 104.942C80.944 104.942 75.6759 108.605 75.6759 111.823V112.465C75.6759 112.465 75.6759 115.596 79.0287 115.596H96.1205C96.1205 115.596 99.2113 115.596 99.2113 112.554V111.823Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_816_29110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.531 108.158H71.1412V113.905H105.531V108.158Z",
    fill: "#231F20"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1912 119.41C81.0311 118.424 85.1371 117.283 88.4185 117.283C92.092 117.283 96.0012 118.424 97.7181 119.41C97.7181 119.41 92.2579 118.768 88.455 118.768C84.6522 118.768 79.1912 119.41 79.1912 119.41Z",
    fill: "#764D34"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPollyShock);
export default __webpack_public_path__ + "static/media/pollyShock.e9bb323c.svg";
export { ForwardRef as ReactComponent };